module.exports = __webpack_public_path__ + "static/img/culture3.efabcb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture3.png
// module id = iof8
// module chunks = 2